<template>
  <form :class="`${$style.container} ${mobileLayout && $style.containerMobile}`">
    <div :class="$style.delete">
      <vs-button icon="delete_outline" @click="$emit('delete')">Удалить перерасчет</vs-button>
    </div>
    <div :class="$style.header">
      <div :class="$style.title">Перерасчет {{ index + 1 }}</div>

      <div :class="$style.apartmentType">
        Тип помещений
        <elsa-v-select
          :class="$style.apartmentTypeSelect"
          :options="apartmentTypes"
          v-model="data.apartmentType"
          label="name"
          :reduce="item => item.id"
          :clearable="false"
          :append-to-body="true"
        />
      </div>
    </div>

    <div :class="$style.body">
      <div :class="$style.accounts">
        <div>
          <vs-radio v-model="data.target" vs-value="house" @change="updateValue">
            По всем помещениям типа "{{ selectedApartmentType.name }}"
          </vs-radio>
        </div>

        <div>
          <vs-radio v-model="data.target" vs-value="accountNumbers" @change="updateValue">
            По отдельным лицевым счетам
          </vs-radio>
        </div>

        <div :class="`${$style.accountsList} ${data.target === 'accountNumbers' && $style.accountsListActive}`">
          <div>
            <div>
              <vs-radio v-model="data.isList" vs-value="true" @change="updateValue">Список</vs-radio>
            </div>
            <div>
              <vs-radio v-model="data.isList" vs-value="false" @change="updateValue">Диапазон</vs-radio>
            </div>
          </div>
          <div :class="$style.accountsInput">
            <elsa-v-select
              v-if="data.isList === 'true'"
              :class="$style.accountsSelect"
              v-model="data.accountNumbers"
              :options="rowSelectData.apartments"
              label="label"
              :reduce="item => item.value"
              :append-to-body="true"
              :clearable="false"
              multiple
              @input="updateValue"
              style-type="multiline"
            />

            <div v-if="data.isList === 'false'" :class="$style.accountsDiapason">
              <elsa-v-select
                :class="$style.accountsEdge"
                v-model="data.accountNumbersFrom"
                :options="rowSelectData.apartments"
                label="label"
                :reduce="item => item.label"
                :append-to-body="true"
                @input="updateValue"
              />
              <span :class="$style.accountsSeparator">-</span>
              <elsa-v-select
                :class="$style.accountsEdge"
                v-model="data.accountNumbersTo"
                :options="rowSelectData.apartments"
                label="label"
                :reduce="item => item.label"
                :append-to-body="true"
                @input="updateValue"
              />
            </div>
          </div>

        </div>
      </div>

      <div :class="$style.meta">
        <vs-input
          :class="$style.input"
          label="Комментарий"
          v-model="data.accountantComment"
          @blur="updateValue"
        />
      </div>
    </div>

    <div :class="$style.tariffs">
      <div :class="$style.title">Применить тарифы:</div>
      <div :class="$style.tariffsContainer">
        <div :class="$style.tariffsList">
          <BulkAddRow
            v-for="(tariff, index) in data.tariffs"
            :ref="`row[${index}]`"
            :key="tariff.id"
            :template="tariffTemplate"
            :mobile-layout="mobileLayout"
            :errors="getTariffErrors(tariff.id)"
            :value="tariff.data"
            :index="index"
            :select-data="rowSelectData"
            :show-check-print="true"
            :aside-checkbox="asideCheckbox"
            @input="onUpdateTariff($event, index)"
            @delete="onDeleteTariff(index)"
            @add-row="onAddTariff(index)"
          />
        </div>
        <div :class="$style.addButtonContainer">
          <vs-button
            :class="$style.addButton"
            size="large"
            icon="add"
            color="#fff"
            @click="onAddTariff()"
          >
            Добавить тариф
          </vs-button>
        </div>
      </div>
    </div>

  </form>
</template>

<script>
import BulkAddRow from "@/components/calculated-program/invoices/BulkAddRow";

export default {
  name:       "RecalculationsAddRow",
  components: { BulkAddRow },
  props:      ['template', 'mobileLayout', 'value', 'selectData', 'types', 'index', 'errors', 'showCheckPrint'],
  data() {
    return {
      data: { ...this.value },

      emptyTariff: {
        id:     null,
        reason: null,
        date:   null,
        value:  null,
        type:   null,
        force:  false,
      },
      idCounter:   1,

      tariffs: [],

      rowSelectData: {
        apartments:         [],
        tariffs:            [],
        recalculationTypes: [
          { value: 0, label: 'Фиксированная сумма на лицевой счет' },
          { value: 1, label: 'По площади' },
          { value: 2, label: 'По постоянно зарегистрированным' },
          { value: 3, label: 'По фактически проживающим' },
          { value: 4, label: 'Перерасчет на сумму начислений' },
        ],
      },

      tariffTemplate: [
        [
          {
            field:     'id',
            type:      'select',
            className: this.$style.tariff,
            label:     'Тариф',
            dataField: 'tariffs',
          },
          {
            field:     'reason',
            type:      'text',
            className: this.$style.reason,
            label:     'Основание',
          },
          {
            field:     'date',
            type:      'month',
            className: this.$style.date,
            label:     'Месяц',
          },
        ],
        [
          {
            field:     'value',
            type:      'currency',
            className: this.$style.value,
            label:     'Значение',
          },
          {
            field:     'type',
            type:      'select',
            className: this.$style.type,
            label:     'Тип перерасчета',
            dataField: 'recalculationTypes',
          },
        ],
      ],

      asideCheckbox: {
        label: 'Квитанции уже<br/>были показаны',
        field: 'force',
      },
    };
  },
  computed:   {
    apartmentTypes() {
      const houses = this.$store.getters['appUser/houses'];
      const apartmentTypes = this.$store.getters['appUser/apartmentsTypes'];
      const selectedHouse = houses.find(h => h.id === this.data.buildingId);
      return selectedHouse.available_types.split(',').reduce(( list, typeId ) => {
        const type = apartmentTypes.find(type => type.id === +typeId);
        if (type) list.push(type);
        return list;
      }, []);
    },

    houses() {
      return this.$store.getters['appUser/houses'];
    },

    selectedApartmentType() {
      const apartmentTypes = this.$store.getters['appUser/apartmentsTypes'];
      return apartmentTypes.find(type => type.id === this.data.apartmentType);
    },
  },
  methods:    {
    checkTariffsEmpty() {
      if (!this.data.tariffs.length) {
        this.data.tariffs = [this.getEmptyTariff()];
        this.updateValue();
      }
    },

    getEmptyTariff() {
      return { id: this.idCounter++, data: { ...this.emptyTariff } };
    },

    onAddTariff() {
      this.data.tariffs.push(this.getEmptyTariff());
    },

    onDeleteTariff( index ) {
      this.data.tariffs.splice(index, 1);
      this.checkTariffsEmpty();
    },

    onUpdateTariff( tariff, index ) {
      this.data.tariffs[index].data = tariff;
      this.updateValue();
    },

    getTariffErrors( index ) {
      const { errors } = this;
      if (!errors || !errors[index]) return {};
      return errors[index];
    },

    loadTariffs() {
      this.$http.get(`tarifs`, { params: { buildings_id: this.data.buildingId } }).then(( { data } ) => {
        this.tariffs = data;
        this.updateSelectTariffs();
      });
    },

    updateSelectTariffs() {
      this.rowSelectData.tariffs = this.tariffs
        .filter(tariff => tariff.apartments_type === this.data.apartmentType)
        .map(tariff => ({ label: tariff.name, value: tariff.id }));
    },

    updateSelectApartments() {
      this.rowSelectData.apartments = this.selectData.apartments
        .filter(account => account.original.type_apart === this.data.apartmentType);
    },

    resetData() {
      this.data.tariffs = [this.getEmptyTariff()];
      this.data.accountNumbers = [];
      this.data.accountNumbersFrom = '';
      this.data.accountNumbersTo = '';
    },

    updateValue() {
      this.$emit('input', this.data);
    },
  },
  mounted() {
    this.loadTariffs();
    this.updateSelectApartments();
    this.checkTariffsEmpty();
  },
  watch:      {
    'data.buildingId'( buildingId ) {
      const houses = this.$store.getters['appUser/houses'];
      const selectedHouse = houses.find(h => h.id === buildingId);
      this.data.apartmentType = +selectedHouse.available_types.split(',')[0];
      this.resetData();
      this.loadTariffs();
    },

    'data.apartmentType'() {
      this.resetData();
      this.updateSelectTariffs();
      this.updateSelectApartments();
    },

    'selectData.apartments'() {
      this.updateSelectApartments();
    },

    value( model ) {
      this.data = { ...model };
      this.checkTariffsEmpty();
    },
  },
};
</script>

<style lang="scss" module>
.container {
  position: relative;
  display: block;
  border: 1px solid #c8c8c8;
  border-radius: 5px;
  min-width: 930px;
  margin: 0 15px 20px;
  padding: 15px;
}

.containerMobile {
  .header {
    flex-direction: column;
    align-items: flex-start;
  }

  .apartmentType {
    margin-left: 0;
    width: 100%;
    margin-top: 15px;
  }

  .body {
    flex-direction: column;
  }

  .accounts {
    margin-bottom: 10px;
    width: 100%;
  }

  .accountsList {
    display: none;
  }

  .accountsListActive {
    display: flex;
  }

  .meta {
    margin-top: 0;
    width: 100%;
    padding: 0;
  }
}

.header {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
}

.title {
  font-size: 1.25em;
  font-weight: 600;
}

.delete {
  position: absolute;
  right: 15px;
  top: 15px;
}

.apartmentType {
  display: flex;
  align-items: center;
  margin-left: 50px;
  flex: 1;
  //margin-bottom: 15px;
}

.apartmentTypeSelect {
  flex: 1;
  max-width: 250px;
  margin-left: 15px;
}

.body {
  margin-bottom: 15px;
  display: flex;
}

.accounts {
  width: 50%;
}

.accountsList {
  margin-top: 5px;
  padding-left: 30px;
  display: flex;
  opacity: 0;
  visibility: hidden;
  @include anim();
}

.accountsListActive {
  opacity: 1;
  visibility: visible;
}

.accountsInput {
  flex: 1;
  padding-top: 6px;
  padding-left: 30px;
  min-width: 0;
}

.accountsDiapason {
  display: flex;
  align-items: center;
}

.accountsSeparator {
  margin: 0 1em;
}

.accountsEdge {
  flex: 1;
}

.meta {
  margin-top: 41px;
  padding-left: 30px;
  width: 50%;
  display: flex;
  align-items: flex-start;
  //margin: 0 -10px;
}

//.comment {
//  flex: 2;
//  padding: 0 10px;
//}

.input {
  width: 100%;
}

.tariffs {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.tariffsContainer {
  margin: 0 -15px;
  //padding: $header_height 0 $footer_height + $button_height;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-bottom: 60px;
  margin-right: 140px;
}

.tariffsList {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;

  &:after {
    content: '';
    position: absolute;
    left: 100%;
    top: 0;
    bottom: 0;
    background: #C8C8C8;
    width: 1px;
  }
}

.addButtonContainer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0 15px 0 85px;
}

.addButton {
  background: #fff;
  width: 100%;
  color: #989898;
  height: 60px;
}

.tariff {
  width: 230px;
}

.reason {
  width: 230px;
}

.date {
  width: 100px;
}

.value {
  width: 100px;
}

.type {
  width: 300px;
}

</style>
